<template>
  <q-drawer
    show-if-above
    :width="width"
    :breakpoint="0"
    bordered
    persistent
    :mini="mini"
    :mini-to-overlay="miniToOverlay"
    @mouseover="$emit('mouseover')"
    @mouseout="$emit('mouseout')"
  >
    <q-scroll-area class="fit">
      <List padding>
        <slot name="prepend" />
        <template v-for="item of menuItems">
          <Item
            :to="item.to"
            :active="isActive(item.key)"
            clickable
            v-ripple
            :key="item.key"
            v-if="!item.children"
            @click="onClick(item)"
          >
            <ItemSection avatar>
              <q-icon :name="item.icon" />
            </ItemSection>

            <ItemSection>
              <ItemLabel>{{ item.label }}</ItemLabel>
            </ItemSection>
          </Item>

          <ItemExpandable
            expand-separator
            :default-opened="childIsActive(item.children)"
            :icon="item.icon"
            :label="item.label"
            :header-class="childIsActive(item.children) ? 'text-primary' : undefined"
            class="item-expandable"
            :class="mini ? 'mini' : ''"
            :key="item.key"
            v-else
          >
            <Item
              :to="child.to"
              :inset-level="0"
              :active="isActive(child.key)"
              clickable
              v-ripple
              v-for="child in item.children"
              :key="child.key"
            >
              <ItemSection side>
                <q-icon />
              </ItemSection>
              <ItemSection>
                <ItemLabel>{{ child.label }}</ItemLabel>
              </ItemSection>
            </Item>
          </ItemExpandable>
          <Separator v-bind:key="`${item.key}-separator`" v-if="item.separator" />
        </template>
        <slot name="append" />
      </List>
    </q-scroll-area>
  </q-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import List from '../components/List.vue';
import Item from '../components/Item.vue';
import ItemSection from '../components/ItemSection.vue';
import ItemExpandable from '../components/ItemExpandable.vue';
import ItemLabel from '../components/ItemLabel.vue';
import Separator from '../components/Separator.vue';

export default {
  name: 'Sidebar',
  components: {
    List,
    Item,
    ItemSection,
    ItemExpandable,
    ItemLabel,
    Separator,
  },
  props: {
    menuItems: {
      type: Array,
      default: () => [],
      // validator: menuItems => menuItems.every(menuItem => ['key']),
    },
    activePath: {
      type: String,
    },
    mini: {
      type: Boolean,
      required: true,
    },
    miniToOverlay: {
      type: Boolean,
    },
    width: {
      type: Number,
      default: 270,
    },
  },
  data() {
    return {
      mouseOver: false,
    };
  },
  computed: {
    ...mapState({
      sideMenuOpen: (state) => state.sideMenuOpen,
    }),
  },
  methods: {
    ...mapMutations(['updateSideMenuOpen']),

    isActive(key) {
      return this.activePath.indexOf(key) !== -1;
    },

    childIsActive(children) {
      const found = children.find((item) => {
        return this.activePath.indexOf(item.key) !== -1;
      });
      return !!found;
    },

    onClick(item) {
      if (item.onClick) item.onClick();
      else this.$emit('click', item.key);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-expandable::v-deep {
  .q-item__section--avatar {
    min-width: 0 !important;
  }

  &.mini {
    .q-item {
      padding: 0 !important;
    }
  }
}

.q-item__section--avatar ::v-deep {
  min-width: auto;
}
</style>
